import React, { useState, useEffect } from "react";
import "./itemCounter.scss";
const ItemCounter = ({ index, onAddToOrder }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (count >= 0) {
      onAddToOrder(count);
    }
  }, [count]);

  const handleIncrement = () => {
    setCount(count + 1);
  };

  const handleDecrement = () => {
    if (count > 0) {
      console.log(count);
      setCount(count - 1);
    }
  };

  return (
    <div className="item-counter">
      <button className="dec-button" onClick={handleDecrement}>
        -
      </button>
      <p>{count}</p>
      <button className="inc-button" onClick={handleIncrement}>
        +
      </button>
    </div>
  );
};

export default ItemCounter;
